import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesOverview from './components/ServicesOverview';
import AIAnswerBlock from './components/AIAnswerBlock';
import ProcessSection from './components/ProcessSection';
import WhyChooseUs from './components/WhyChooseUs';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <TrustBar />
      <ServicesOverview />
      <AIAnswerBlock />
      <ProcessSection />
      <WhyChooseUs />
      <ServiceAreas />
      <Testimonials />
      <FAQSection />
      <FinalCTA />
    </main>
  );
}
